import classNames from 'clsx';
import React, { memo } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';

import styles from './FileIcon.css';

interface IProps {
    type?: string | null;
    view?: EViewMode;
    flat?: boolean;
    showIcon?: boolean;
    mode?: 'dark' | 'light';
}

const FileIcon = ({ type = '', view = EViewMode.list, showIcon = true, flat = false, mode }: IProps) => {
    if (!showIcon) {
        return null;
    }

    return (
        <div
            className={classNames({
                [styles.root]: true,
                [styles[`root_view_${view}`]]: Boolean(view),
                [styles.root_flat]: !!flat,
                [styles[`root_${mode}`]]: Boolean(mode),
            })}
        >
            <div
                className={classNames({
                    [styles.icon]: true,
                    [styles[`icon_type_${type}`]]: type,
                })}
            />
        </div>
    );
};

export default memo(FileIcon);
